import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccTeamVenture } from '@interfaces';


export function getColumns(util: UtilityService) {
	const columns: GridColumn<AccTeamVenture, unknown>[] = [
		buildColumn(util, 'Id', row => row.accVentureId),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.entrepreneurs, { header: 'Entrepreneurs' }),
		buildColumn(util, 'Text', row => row.status, { header: 'Status' }),
		buildColumn(util, 'YesNo', row => !!row.dropout, { header: 'Dropped Out' }),
		buildColumn(util, 'Number', row => row.dropout?.dropoutWeek, { header: 'Drop-out Week' }),	];

	return columns;

}
